import toast from "react-hot-toast";

// One place that turns a Domain publish/withdraw outcome into the toast the
// agent sees, so both property detail pages behave the same. `result` is the
// property PUT's `domain_sync` or the crawler PATCH's portal_sync "domain"
// entry (same shape: success / pending / blocked / message|reason / warnings).
// Only Domain results come through here; REA toasts are untouched.
export function notifyDomainResult(result, turnedOn) {
  const verb = turnedOn ? "publish to" : "unpublish from";
  if (!result) {
    toast.success(turnedOn ? "Published to Domain" : "Unpublished from Domain");
    return;
  }
  const message = result.message || result.reason || "";
  if (result.blocked) {
    toast.error(message || "Not published to Domain - listing not ready.", { duration: 8000 });
    return;
  }
  if (result.pending) {
    toast(message || "Domain is still processing this - check back shortly.");
  } else if (result.success === false && result.sent !== false) {
    toast.error(`Failed to ${verb} Domain: ${message}`, { duration: 8000 });
    return;
  } else {
    toast.success(turnedOn ? "Published to Domain" : "Unpublished from Domain");
  }
  (result.warnings || []).forEach((warning) => {
    toast(warning, { icon: "⚠️", duration: 10000, style: { background: "#FFFBEB", color: "#92400E" } });
  });
}
